
<script setup>

  import { ref, computed } from 'vue';

  import { useRoute } from 'vue-router';

  import { TransitionRoot, TransitionChild, Dialog, DialogPanel, DialogTitle } from '@headlessui/vue';

  import { XCircleIcon } from '@heroicons/vue/24/outline';

  import { parts } from '../stores/activity-2.js'

  import backgroundPath from '../images/road-trip-background.jpg';

  import imagePaths from '../images/activity-2-road-trip-*.png';

  const route = useRoute();

  const isOpen = ref( false );

  const part = computed( () => ( route.path.match( /part\/(\d+)/ ) ?? [] )[ 1 ] );

  const images = Object.values( imagePaths );

  const items = ref( [] );

  function open() {
    
    isOpen.value = true;

    setTimeout( () => {

      items.value[ parseInt( part.value ) - 1 ].scrollIntoView( { behavior: 'smooth', block: 'end', inline: 'center' } );

    }, 500 );

  }

  function close() {
    
    isOpen.value = false;

  }

  defineExpose( { open, close } );

</script>

<template>

  <TransitionRoot appear :show="isOpen" as="template">

    <Dialog as="div" @close="close" class="fixed inset-0 overflow-hidden z-20 drop-shadow-[0_0_15px_rgba(0,0,0,0.5)]">

      <div class="absolute inset-x-0 bottom-0 overflow-hidden">

        <TransitionChild

          as="template"

          enter="transition transform duration-300 ease-out"

          enter-from="translate-y-full"

          enter-to="translate-y-0"

          leave="transition transform duration-200 ease-in"

          leave-from="translate-y-0"

          leave-to="translate-y-full">

          <DialogPanel class="flex flex-col w-screen max-h-screen overflow-hidden bg-white bg-center bg-cover"
          
            :style="{ backgroundImage: `url( ${ backgroundPath } )` }">
            
            <div class="flex items-center justify-between gap-5 p-5">

              <DialogTitle as="h3" class="text-2xl md:text-4xl font-heading uppercase">

                Road Trip Progress Review

              </DialogTitle>

              <button type="button" @click="close" class="group flex items-center gap-2">

                <div class="text-sm group-focus-visible:underline group-hover:underline">Close</div>

                <XCircleIcon class="w-8" />
              
              </button>

            </div>

            <div class="flex items-center overfloy-y-hidden overflow-x-scroll">

              <template v-for="( { subtitle, description }, number, index ) in parts">

                <img class="h-48 mx-16" src="../images/activity-2-roadtrip-arrow.png" alt="" v-if="index > 0" />

                <div ref="items"
                
                  :class="[ 'place-self-start min-w-[100vw] md:min-w-[450px] md:max-w-[450px] px-8', { 'opacity-25': number > part } ]">

                  <div :class="[ 'w-full h-[240px]', { grayscale: number > part } ]">

                    <img :src="images[ index ]" alt="" class="w-full h-full object-contain" v-if="images[ index ]" draggable="false" />

                  </div>

                  <div class="font-semibold">Part {{ number }}</div>

                  <div class="font-semibold text-xl uppercase">{{ subtitle }}</div>

                  <p class="mt-4 mb-8" v-if="number <= part">{{ description }}</p>

                </div>

              </template>

            </div>

          </DialogPanel>

        </TransitionChild>

      </div>

    </Dialog>

  </TransitionRoot>

</template>
